<template>
  <SectionContainerPage>
    <v-layout column>
      <v-flex>
        <SectionActivityDetail
          :breadCrumbs="breadCrumbs"
          @onClickBreadcrumb="(val) => $emit('onClickBreadcrumb', val)"
          :title="
            _entityPropertyValueByName({
              entityList: activityTypeList,
              idKey: 'id',
              idValue: activityDetail.typeId,
              propertyKey: 'name',
            })
          "
          :toolbarActions="[
            {
              text: 'Edit Activity',
              icon: 'edit',
              iconColor: 'warning',
              emitEvent: 'onEditActivityClicked',
            },
          ]"
          @onEditActivityClicked="showConfirmWantEditActivity"
          :activityDetail="activityDetail"
          :modelList="modelList"
          :manufacturerList="manufacturerList"
          :categoryList="categoryList"
          :activityTypeList="activityTypeList"
          :assetStatusList="assetStatusList"
          :locationList="locationList"
          :clientList="clientList"
          :userList="userList"
          :isLoading="isLoading"
        />
      </v-flex>
      <v-flex>
        <v-tabs dark v-model="currentTab">
          <v-tab>
            <v-icon class="mr-1">construction</v-icon
            >{{
              `Equipment (${
                (activityDetail.assetList && activityDetail.assetList.length) ||
                0
              })`
            }}
          </v-tab>
          <v-tab>
            <v-icon class="mr-1">attachment</v-icon
            >{{
              `Attachments (${
                (activityDetail.attachmentList &&
                  activityDetail.attachmentList.length) ||
                0
              })`
            }}
          </v-tab>
        </v-tabs>
      </v-flex>
      <v-flex v-if="currentTab === tabAssets">
        <SectionAssetList
          xs12
          :isPrimary="false"
          title="Activity Equipment"
          @onClickViewEquipment="
            (val) =>
              $emit('onClickViewEquipmentFromActivityDetail', {
                ...val,
                breadCrumbTitle: _entityPropertyValueByName({
                  entityList: activityTypeList,
                  idKey: 'id',
                  idValue: activityDetail.typeId,
                  propertyKey: 'name',
                }),
              })
          "
          :shouldShowCheckBoxes="false"
          :assetList="activityDetail.assetList || []"
          :modelList="modelList"
          :manufacturerList="manufacturerList"
          :categoryList="categoryList"
          :activityTypeList="activityTypeList"
          :assetStatusList="assetStatusList"
          :locationList="locationList"
          :clientList="clientList"
          :userList="userList"
          :isLoading="isLoading"
        />
      </v-flex>
      <v-flex v-if="currentTab === tabAttachments">
        <SectionAttachmentList
          xs12
          :isPrimary="false"
          title="Activity Attachments"
          @onClickUnlinkAttachment="(val) => onConfirmUnlinkAttachment(val)"
          @onClickViewAttachment="(val) => onClickViewAttachment(val)"
          :attachmentList="activityDetail.attachmentList || []"
          :activityTypeList="activityTypeList"
          :userList="userList"
          :locationList="locationList"
          :modelList="modelList"
          :isLoading="isLoading"
          :showUnlinkButton="true"
        />
      </v-flex>
    </v-layout>
    <DialogFormActivityEdit
      :showDialog="showDialogFormActivityEdit"
      @onCancelClicked="showDialogFormActivityEdit = false"
      @onSubmitClicked="(val) => [onDialogFormActivityEditSubmit(val)]"
      :activityDetail="activityDetail"
      :activityTypeList="activityTypeList"
      :assetStatusList="assetStatusList"
      :clientList="clientList"
      :userList="userList"
      :locationList="locationList"
      :modelList="modelList"
      :isLoading="isLoading"
    />
    <DialogFormConfirmation
      :showDialog="confirmationDialogShow"
      :title="confirmationDialogTitle"
      :message="confirmationDialogMessage"
      :submitButtonText="confirmationDialogSubmitButtonText"
      :submitButtonIcon="confirmationDialogSubmitButtonIcon"
      :submitButtonColor="confirmationDialogSubmitButtonColor"
      :cancelButtonText="confirmationDialogCancelButtonText"
      :showCancelButton="confirmationDialogShowCancelButton"
      @onSubmitClicked="onConfirmationDialogSubmitClicked"
      @onCancelClicked="onConfirmationDialogCancelClicked"
      :isLoading="isLoading"
    />
  </SectionContainerPage>
</template>

<script>
import mixinAssetApi from '../../../common/mixins/mixinAssetApi'
import mixinAssetHelper from '../../../common/mixins/mixinAssetHelper'
import mixinConfirmationDialog from '../../../common/mixins/mixinConfirmationDialog'

import SectionContainerPage from '../../../common/components/layouts/SectionContainerPage'
import SectionActivityDetail from './sections/SectionActivityDetail'
import SectionAssetList from './sections/SectionAssetList'
import SectionAttachmentList from './sections/SectionAttachmentList'

import DialogFormActivityEdit from '../dialogs/DialogFormActivityEdit'
import DialogFormConfirmation from '../dialogs/DialogFormConfirmation'

const TAB_ASSETS = 0
const TAB_ATTACHMENTS = 1

export default {
  components: {
    SectionContainerPage,
    SectionActivityDetail,
    SectionAssetList,
    SectionAttachmentList,

    DialogFormActivityEdit,
    DialogFormConfirmation,
  },
  mixins: [mixinAssetApi, mixinAssetHelper, mixinConfirmationDialog],
  props: {
    activityId: {
      type: Number,
      required: true,
    },
    breadCrumbs: Array,
  },
  data: () => ({
    currentTab: TAB_ASSETS,
    tabAssets: TAB_ASSETS,
    tabAttachments: TAB_ATTACHMENTS,
    showDialogFormActivityEdit: false,
    showDialogConfirmation: false,
    activityDetail: {},
    propertyToEdit: {},
    modelList: [],
    manufacturerList: [],
    categoryList: [],
    activityTypeList: [],
    assetStatusList: [],
    locationList: [],
    clientList: [],
    userList: [],
    isLoadingCount: 0,
  }),
  activated() {
    this.currentTab = this.tabAssets
    this.fetchActivityDetail()
    this.fetchLists()
  },
  computed: {
    isLoading() {
      return this.isLoadingCount > 0
    },
  },
  watch: {
    isLoading() {
      this.$emit('isLoadingChange', this.isLoading)
    },
  },
  methods: {
    onClickViewAttachment(val) {
      this.$emit('onClickViewAttachmentFromActivityDetail', {
        ...val,
        breadCrumbTitle: this._entityPropertyValueByName({
          entityList: this.activityTypeList,
          idKey: 'id',
          idValue: this.activityDetail.typeId,
          propertyKey: 'name',
        }),
      })
    },
    showConfirmWantEditActivity() {
      this.showConfirmationDialog({
        title: 'Are you sure you would like to edit this activity?',
        message:
          'Please confirm that you would like to edit this "' +
          this._entityPropertyValueByName({
            entityList: this.activityTypeList,
            idKey: 'id',
            idValue: this.activityDetail.typeId,
            propertyKey: 'name',
          }) +
          '" activity. Modifications will impact all equipment linked to this activity. Proceed with caution.',
        submitButtonText: undefined,
        cancelButtonText: undefined,
        submitCb: () => {
          this.showDialogFormActivityEdit = true
        },
        cancelCb: () => {},
      })
    },
    onConfirmUnlinkAttachment({ attachmentId, fileName } = {}) {
      this.showConfirmationDialog({
        submitButtonText: 'Unlink',
        submitButtonIcon: 'link_off',
        submitButtonColor: 'error',
        message:
          `Please confirm that you would like to unlink attachment "${fileName}" from this "` +
          this._entityPropertyValueByName({
            entityList: this.activityTypeList,
            idKey: 'id',
            idValue: this.activityDetail.typeId,
            propertyKey: 'name',
          }) +
          '" activity.',
        showCancelButton: true,
        submitCb: () => {
          this.isLoadingCount++
          this._deleteActivityAttachmentLink({
            activityId: this.activityId,
            attachmentId: attachmentId,
            successCb: () => {
              this.isLoadingCount--
              this.fetchActivityDetail()
              this.$emit('notify', {
                message: 'Attachment successfully unlinked!',
              })
            },
            failedCb: (error) => {
              this.isLoadingCount--
              this.showConfirmationDialog({
                title: 'Error occured',
                showCancelButton: false,
                message: this._getMessageFromErrorResponse(error),
                submitButtonText: 'Continue',
              })
            },
          })
        },
        cancelCb: () => {},
      })
    },
    onDialogFormActivityEditSubmit(data) {
      this.showConfirmationDialog({
        title: 'Are you sure...',
        submitButtonText: 'Save',
        submitButtonIcon: 'save',
        submitButtonColor: 'success',
        message:
          'Saving this "' +
          this._entityPropertyValueByName({
            entityList: this.activityTypeList,
            idKey: 'id',
            idValue: this.activityDetail.typeId,
            propertyKey: 'name',
          }) +
          '" activity will impact all equipment linked. Please confirm once more to save the activity.',
        showCancelButton: true,
        submitCb: () => {
          this.isLoadingCount++
          this._updateActivity({
            id: this.activityDetail.id,
            typeId: data.typeId,
            dateTimeEpochPerformedOn: data.dateTimeEpochPerformedOn,
            userIdPerformedBy: data.userIdPerformedBy,
            locationId: data.locationId,
            files: data.files,
            statusId: data.statusId,
            comments: data.comments,
            successCb: () => {
              this.isLoadingCount--
              this.showDialogFormActivityEdit = false
              this.fetchActivityDetail()
              this.$emit('notify', {
                message: 'Activity successfully updated!',
              })
            },
            failedCb: (error) => {
              this.isLoadingCount--
              this.showConfirmationDialog({
                title: 'Error occured',
                showCancelButton: false,
                message: this._getMessageFromErrorResponse(error),
                submitButtonText: 'Continue',
              })
            },
          })
        },
        cancelCb: () => {},
      })
    },
    fetchActivityDetail() {
      this.isLoadingCount++
      this._fetchActivityDetail({
        activityId: this.activityId,
        successCb: (data) => {
          this.isLoadingCount--
          this.activityDetail = data
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    fetchLists() {
      this.isLoadingCount++
      this._fetch({
        types: [
          'Status',
          'Model',
          'Manufacturer',
          'Category',
          'ActivityType',
          'Location',
          'Client',
          'User',
        ],
        successCb: (data) => {
          this.isLoadingCount--
          this.modelList = data.models
          this.manufacturerList = data.manufacturers
          this.categoryList = data.categories
          this.activityTypeList = data.activityTypes
          this.assetStatusList = data.statuses
          this.locationList = data.locations
          this.clientList = data.clients
          this.userList = data.users
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.assetStatusList = []
          this.modelList = []
          this.manufacturerList = []
          this.categoryList = []
          this.activityTypeList = []
          this.locationList = []
          this.clientList = []
          this.userList = []
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
  },
}
</script>
